//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

// TODO: PD-263920: The frontend CommunicationType appears to just be a tiny type that is casted as "DM"
/**
 * Communication type is set to DM to Indentify the rights requested via Istagram Direct message workflow .
 */
type CommunicationType = Opaque<string, 'DM'>;

function CommunicationTypeFactory(CommunicationType: string) {
  return CommunicationType as CommunicationType;
}

const CommunicationType = CommunicationTypeFactory;

export default CommunicationType;
